import axios, { AxiosInstance, AxiosResponse } from 'axios';

// Create a new axios instance
const api: AxiosInstance = axios.create({
  // baseURL: 'https://11f8-117-28-212-240.ngrok-free.app',
  // baseURL: 'http://ip-cats.com',
  timeout: 30 * 1000,
  withCredentials: true,
});

// Add a request interceptor
api.interceptors.request.use(
  (config) => {
    // Do something before request is sent
    return config;
  },
  (error: any) => {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
api.interceptors.response.use(
  (response: AxiosResponse) => {
    // Do something with response data
    if (response.data?.code !== 200) {
      return Promise.reject(response.data);
    }
    return response;
  },
  (error: any) => {
    if (error.response.status === 401) {
      window.location.pathname = '/my-account';
    }
    // Do something with response error
    return Promise.reject(error);
  }
);

export default api;
